import { el } from "@dhx/ts-common/dom";

export function customHTMLButton(item: any, widgetName?: string, asMenuItem?: boolean) {
	const baseClass = asMenuItem ? " dhx_button dhx_menu-button" : " dhx_button dhx_nav-menu-button";
	return el("button", {
		"class": "dhx_custom-button" + baseClass + (item.$activeParent ? baseClass + "--active" : ""),
		"dhx_id": item.id,
		"type": "button",
		".innerHTML": item.html
	}, item.html ? "" : item.value);
}